export default {
  wechatBridgeError: 'wechat bridge loading error',
  alipayBridgeError: 'alipay bridge loading error',
  mqqBridgeError: 'mqq bridge loading error'
}
